import { AttributeInfoDto } from '@cloud-twin-v2/generated/simulation.generated.client';

export class GridAttributeValue extends AttributeInfoDto {
  value: string;
  resultDateTime: Date;
  formattedValue: string;

  constructor(init: Partial<GridAttributeValue>) {
    super(init);
    Object.assign(this, init);
  }
}

export class ChartAttributes {
  name: string;
  values: GridAttributeValue[];

  constructor(init: Partial<ChartAttributes>) {
    Object.assign(this, init);
  }
}
